export const ExperimentsConsts = {
  WixTipsMatchCurrencyWithEcom: 'specs.bookings.WixTipsMatchCurrencyWithEcom',
  noTipsWhenHasSubscription: 'specs.tips.noTipsWhenHasSubscription',
};
